import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const vesselService = {
  getAll: async () => {
    return await axios.get(`${domain}/api/Vessel`, { headers });
  },
  getActive: async () => {
    return await axios.get(`${domain}/api/Vessel/active`, { headers });
  }
};

export default vesselService;